import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ResourcesPage } from './ResourcesPage';

const resourcesSearchSchema = z.object({
  category: z.array(z.string()).optional().catch(undefined),
  status: z.enum(['all', 'saved', 'applied']).default('all').catch('all'),
});

export const Route = createFileRoute('/_protected/_consumer/resources/')({
  component: ResourcesPage,
  validateSearch: resourcesSearchSchema,
});
